import { useState } from "react";
import { ChevronRight } from "lucide-react";
import { SelectMethodDialog } from "../booking/SelectMethodDialog";
import { useBookingTimeGuard } from "../../hooks/useBookingTimeGuard";
import BookingTimeoutDialog from "../booking/BookingTimeoutDialog";

export function BookingButton({
  isMobile,
  children,
}: {
  isMobile?: boolean;
  children?: React.ReactNode;
}) {
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const {
    checkBookingTime,
    dialogOpen,
    dialogType,
    closeDialog,
  } = useBookingTimeGuard();

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    const isValidBookingTime = checkBookingTime();

    if (!isValidBookingTime) {
      e.preventDefault();
      return;
    }

    if (isMobile) {
      return;
    }

    e.preventDefault();
    setIsDialogOpen(true);
  };

  return (
    <>
      <a
        href={isMobile ? "/dat-hen" : undefined}
        onClick={handleClick}
        className="
          group relative inline-flex w-[300px] md:w-auto cursor-pointer items-center justify-center gap-2
          overflow-hidden rounded-full border border-white/45
          bg-[linear-gradient(135deg,#104c2d_0%,#2b8a4c_52%,#9bdc72_100%)]
          px-7 py-3 text-base font-semibold text-white
          shadow-[0_10px_30px_rgba(7,32,18,0.35),inset_0_1px_0_rgba(255,255,255,0.28)]
          shadow-[0_14px_38px_rgba(20,60,30,0.35)]
          transition-all duration-300
          hover:-translate-y-[1px] hover:scale-[1.01]
          hover:shadow-[0_16px_42px_rgba(20,80,38,0.42),0_0_30px_rgba(180,255,120,0.18)]
           md:px-9 md:text-[1.05rem]
        "
      >
        <span className="absolute inset-[1px] rounded-full bg-[linear-gradient(180deg,rgba(255,255,255,0.12),rgba(255,255,255,0.03))]" />
        <span className="relative z-[1]">{children}</span>
        <span className="absolute inset-y-0 left-[-30%] w-[38%] rotate-[18deg] bg-white/18 blur-xl transition-all duration-500 group-hover:left-[100%]" />
      </a>

      <SelectMethodDialog
        isOpen={isDialogOpen}
        onOpenChange={(open) => setIsDialogOpen(open)}
      />

      <BookingTimeoutDialog
        isOpen={dialogOpen}
        type={dialogType}
        onClose={closeDialog}
      />
    </>
  );
}